'use strict';

var _slicedToArray = require("C:\\Users\\Drews\\Lambda\\Personal Projects\\BlockStack-App\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _toConsumableArray = require("C:\\Users\\Drews\\Lambda\\Personal Projects\\BlockStack-App\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _classCallCheck = require("C:\\Users\\Drews\\Lambda\\Personal Projects\\BlockStack-App\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\Drews\\Lambda\\Personal Projects\\BlockStack-App\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var bip174_1 = require('bip174');

var varuint = require('bip174/src/lib/converter/varint');

var utils_1 = require('bip174/src/lib/utils');

var address_1 = require('./address');

var bufferutils_1 = require('./bufferutils');

var crypto_1 = require('./crypto');

var ecpair_1 = require('./ecpair');

var networks_1 = require('./networks');

var payments = require('./payments');

var bscript = require('./script');

var transaction_1 = require('./transaction');
/**
 * These are the default arguments for a Psbt instance.
 */


var DEFAULT_OPTS = {
  /**
   * A bitcoinjs Network object. This is only used if you pass an `address`
   * parameter to addOutput. Otherwise it is not needed and can be left default.
   */
  network: networks_1.bitcoin,

  /**
   * When extractTransaction is called, the fee rate is checked.
   * THIS IS NOT TO BE RELIED ON.
   * It is only here as a last ditch effort to prevent sending a 500 BTC fee etc.
   */
  maximumFeeRate: 5000
};
/**
 * Psbt class can parse and generate a PSBT binary based off of the BIP174.
 * There are 6 roles that this class fulfills. (Explained in BIP174)
 *
 * Creator: This can be done with `new Psbt()`
 * Updater: This can be done with `psbt.addInput(input)`, `psbt.addInputs(inputs)`,
 *   `psbt.addOutput(output)`, `psbt.addOutputs(outputs)` when you are looking to
 *   add new inputs and outputs to the PSBT, and `psbt.updateGlobal(itemObject)`,
 *   `psbt.updateInput(itemObject)`, `psbt.updateOutput(itemObject)`
 *   addInput requires hash: Buffer | string; and index: number; as attributes
 *   and can also include any attributes that are used in updateInput method.
 *   addOutput requires script: Buffer; and value: number; and likewise can include
 *   data for updateOutput.
 *   For a list of what attributes should be what types. Check the bip174 library.
 *   Also, check the integration tests for some examples of usage.
 * Signer: There are a few methods. signAllInputs and signAllInputsAsync, which will search all input
 *   information for your pubkey or pubkeyhash, and only sign inputs where it finds
 *   your info. Or you can explicitly sign a specific input with signInput and
 *   signInputAsync. For the async methods you can create a SignerAsync object
 *   and use something like a hardware wallet to sign with. (You must implement this)
 * Combiner: psbts can be combined easily with `psbt.combine(psbt2, psbt3, psbt4 ...)`
 *   the psbt calling combine will always have precedence when a conflict occurs.
 *   Combine checks if the internal bitcoin transaction is the same, so be sure that
 *   all sequences, version, locktime, etc. are the same before combining.
 * Input Finalizer: This role is fairly important. Not only does it need to construct
 *   the input scriptSigs and witnesses, but it SHOULD verify the signatures etc.
 *   Before running `psbt.finalizeAllInputs()` please run `psbt.validateSignaturesOfAllInputs()`
 *   Running any finalize method will delete any data in the input(s) that are no longer
 *   needed due to the finalized scripts containing the information.
 * Transaction Extractor: This role will perform some checks before returning a
 *   Transaction object. Such as fee rate not being larger than maximumFeeRate etc.
 */

var Psbt =
/*#__PURE__*/
function () {
  function Psbt() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new bip174_1.Psbt(new PsbtTransaction());

    _classCallCheck(this, Psbt);

    this.data = data; // set defaults

    this.opts = Object.assign({}, DEFAULT_OPTS, opts);
    this.__CACHE = {
      __NON_WITNESS_UTXO_TX_CACHE: [],
      __NON_WITNESS_UTXO_BUF_CACHE: [],
      __TX_IN_CACHE: {},
      __TX: this.data.globalMap.unsignedTx.tx
    };
    if (this.data.inputs.length === 0) this.setVersion(2); // Make data hidden when enumerating

    var dpew = function dpew(obj, attr, enumerable, writable) {
      return Object.defineProperty(obj, attr, {
        enumerable: enumerable,
        writable: writable
      });
    };

    dpew(this, '__CACHE', false, true);
    dpew(this, 'opts', false, true);
  }

  _createClass(Psbt, [{
    key: "combine",
    value: function combine() {
      var _this$data;

      for (var _len = arguments.length, those = new Array(_len), _key = 0; _key < _len; _key++) {
        those[_key] = arguments[_key];
      }

      (_this$data = this.data).combine.apply(_this$data, _toConsumableArray(those.map(function (o) {
        return o.data;
      })));

      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      // TODO: more efficient cloning
      var res = Psbt.fromBuffer(this.data.toBuffer());
      res.opts = JSON.parse(JSON.stringify(this.opts));
      return res;
    }
  }, {
    key: "setMaximumFeeRate",
    value: function setMaximumFeeRate(satoshiPerByte) {
      check32Bit(satoshiPerByte); // 42.9 BTC per byte IS excessive... so throw

      this.opts.maximumFeeRate = satoshiPerByte;
    }
  }, {
    key: "setVersion",
    value: function setVersion(version) {
      check32Bit(version);
      checkInputsForPartialSig(this.data.inputs, 'setVersion');
      var c = this.__CACHE;
      c.__TX.version = version;
      c.__EXTRACTED_TX = undefined;
      return this;
    }
  }, {
    key: "setLocktime",
    value: function setLocktime(locktime) {
      check32Bit(locktime);
      checkInputsForPartialSig(this.data.inputs, 'setLocktime');
      var c = this.__CACHE;
      c.__TX.locktime = locktime;
      c.__EXTRACTED_TX = undefined;
      return this;
    }
  }, {
    key: "setInputSequence",
    value: function setInputSequence(inputIndex, sequence) {
      check32Bit(sequence);
      checkInputsForPartialSig(this.data.inputs, 'setInputSequence');
      var c = this.__CACHE;

      if (c.__TX.ins.length <= inputIndex) {
        throw new Error('Input index too high');
      }

      c.__TX.ins[inputIndex].sequence = sequence;
      c.__EXTRACTED_TX = undefined;
      return this;
    }
  }, {
    key: "addInputs",
    value: function addInputs(inputDatas) {
      var _this = this;

      inputDatas.forEach(function (inputData) {
        return _this.addInput(inputData);
      });
      return this;
    }
  }, {
    key: "addInput",
    value: function addInput(inputData) {
      checkInputsForPartialSig(this.data.inputs, 'addInput');
      var c = this.__CACHE;
      this.data.addInput(inputData);
      var txIn = c.__TX.ins[c.__TX.ins.length - 1];
      checkTxInputCache(c, txIn);
      var inputIndex = this.data.inputs.length - 1;
      var input = this.data.inputs[inputIndex];

      if (input.nonWitnessUtxo) {
        addNonWitnessTxCache(this.__CACHE, input, inputIndex);
      }

      c.__FEE = undefined;
      c.__FEE_RATE = undefined;
      c.__EXTRACTED_TX = undefined;
      return this;
    }
  }, {
    key: "addOutputs",
    value: function addOutputs(outputDatas) {
      var _this2 = this;

      outputDatas.forEach(function (outputData) {
        return _this2.addOutput(outputData);
      });
      return this;
    }
  }, {
    key: "addOutput",
    value: function addOutput(outputData) {
      checkInputsForPartialSig(this.data.inputs, 'addOutput');
      var _outputData = outputData,
          address = _outputData.address;

      if (typeof address === 'string') {
        var network = this.opts.network;
        var script = address_1.toOutputScript(address, network);
        outputData = Object.assign(outputData, {
          script: script
        });
      }

      var c = this.__CACHE;
      this.data.addOutput(outputData);
      c.__FEE = undefined;
      c.__FEE_RATE = undefined;
      c.__EXTRACTED_TX = undefined;
      return this;
    }
  }, {
    key: "extractTransaction",
    value: function extractTransaction(disableFeeCheck) {
      if (!this.data.inputs.every(isFinalized)) throw new Error('Not finalized');
      var c = this.__CACHE;

      if (!disableFeeCheck) {
        checkFees(this, c, this.opts);
      }

      if (c.__EXTRACTED_TX) return c.__EXTRACTED_TX;

      var tx = c.__TX.clone();

      inputFinalizeGetAmts(this.data.inputs, tx, c, true);
      return tx;
    }
  }, {
    key: "getFeeRate",
    value: function getFeeRate() {
      return getTxCacheValue('__FEE_RATE', 'fee rate', this.data.inputs, this.__CACHE);
    }
  }, {
    key: "getFee",
    value: function getFee() {
      return getTxCacheValue('__FEE', 'fee', this.data.inputs, this.__CACHE);
    }
  }, {
    key: "finalizeAllInputs",
    value: function finalizeAllInputs() {
      var _this3 = this;

      utils_1.checkForInput(this.data.inputs, 0); // making sure we have at least one

      range(this.data.inputs.length).forEach(function (idx) {
        return _this3.finalizeInput(idx);
      });
      return this;
    }
  }, {
    key: "finalizeInput",
    value: function finalizeInput(inputIndex) {
      var input = utils_1.checkForInput(this.data.inputs, inputIndex);

      var _getScriptFromInput = getScriptFromInput(inputIndex, input, this.__CACHE),
          script = _getScriptFromInput.script,
          isP2SH = _getScriptFromInput.isP2SH,
          isP2WSH = _getScriptFromInput.isP2WSH,
          isSegwit = _getScriptFromInput.isSegwit;

      if (!script) throw new Error("No script found for input #".concat(inputIndex));
      var scriptType = classifyScript(script);
      if (!canFinalize(input, script, scriptType)) throw new Error("Can not finalize input #".concat(inputIndex));
      checkPartialSigSighashes(input);

      var _getFinalScripts = getFinalScripts(script, scriptType, input.partialSig, isSegwit, isP2SH, isP2WSH),
          finalScriptSig = _getFinalScripts.finalScriptSig,
          finalScriptWitness = _getFinalScripts.finalScriptWitness;

      if (finalScriptSig) this.data.updateInput(inputIndex, {
        finalScriptSig: finalScriptSig
      });
      if (finalScriptWitness) this.data.updateInput(inputIndex, {
        finalScriptWitness: finalScriptWitness
      });
      if (!finalScriptSig && !finalScriptWitness) throw new Error("Unknown error finalizing input #".concat(inputIndex));
      this.data.clearFinalizedInput(inputIndex);
      return this;
    }
  }, {
    key: "validateSignaturesOfAllInputs",
    value: function validateSignaturesOfAllInputs() {
      var _this4 = this;

      utils_1.checkForInput(this.data.inputs, 0); // making sure we have at least one

      var results = range(this.data.inputs.length).map(function (idx) {
        return _this4.validateSignaturesOfInput(idx);
      });
      return results.reduce(function (_final, res) {
        return res === true && _final;
      }, true);
    }
  }, {
    key: "validateSignaturesOfInput",
    value: function validateSignaturesOfInput(inputIndex, pubkey) {
      var input = this.data.inputs[inputIndex];
      var partialSig = (input || {}).partialSig;
      if (!input || !partialSig || partialSig.length < 1) throw new Error('No signatures to validate');
      var mySigs = pubkey ? partialSig.filter(function (sig) {
        return sig.pubkey.equals(pubkey);
      }) : partialSig;
      if (mySigs.length < 1) throw new Error('No signatures for this pubkey');
      var results = [];
      var hashCache;
      var scriptCache;
      var sighashCache;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = mySigs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var pSig = _step.value;
          var sig = bscript.signature.decode(pSig.signature);

          var _ref = sighashCache !== sig.hashType ? getHashForSig(inputIndex, Object.assign({}, input, {
            sighashType: sig.hashType
          }), this.__CACHE) : {
            hash: hashCache,
            script: scriptCache
          },
              hash = _ref.hash,
              script = _ref.script;

          sighashCache = sig.hashType;
          hashCache = hash;
          scriptCache = script;
          checkScriptForPubkey(pSig.pubkey, script, 'verify');
          var keypair = ecpair_1.fromPublicKey(pSig.pubkey);
          results.push(keypair.verify(hash, sig.signature));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return results.every(function (res) {
        return res === true;
      });
    }
  }, {
    key: "signAllInputsHD",
    value: function signAllInputsHD(hdKeyPair) {
      var sighashTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [transaction_1.Transaction.SIGHASH_ALL];

      if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) {
        throw new Error('Need HDSigner to sign input');
      }

      var results = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = range(this.data.inputs.length)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var i = _step2.value;

          try {
            this.signInputHD(i, hdKeyPair, sighashTypes);
            results.push(true);
          } catch (err) {
            results.push(false);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (results.every(function (v) {
        return v === false;
      })) {
        throw new Error('No inputs were signed');
      }

      return this;
    }
  }, {
    key: "signAllInputsHDAsync",
    value: function signAllInputsHDAsync(hdKeyPair) {
      var _this5 = this;

      var sighashTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [transaction_1.Transaction.SIGHASH_ALL];
      return new Promise(function (resolve, reject) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) {
          return reject(new Error('Need HDSigner to sign input'));
        }

        var results = [];
        var promises = [];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = range(_this5.data.inputs.length)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var i = _step3.value;
            promises.push(_this5.signInputHDAsync(i, hdKeyPair, sighashTypes).then(function () {
              results.push(true);
            }, function () {
              results.push(false);
            }));
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return Promise.all(promises).then(function () {
          if (results.every(function (v) {
            return v === false;
          })) {
            return reject(new Error('No inputs were signed'));
          }

          resolve();
        });
      });
    }
  }, {
    key: "signInputHD",
    value: function signInputHD(inputIndex, hdKeyPair) {
      var _this6 = this;

      var sighashTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [transaction_1.Transaction.SIGHASH_ALL];

      if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) {
        throw new Error('Need HDSigner to sign input');
      }

      var signers = getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
      signers.forEach(function (signer) {
        return _this6.signInput(inputIndex, signer, sighashTypes);
      });
      return this;
    }
  }, {
    key: "signInputHDAsync",
    value: function signInputHDAsync(inputIndex, hdKeyPair) {
      var _this7 = this;

      var sighashTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [transaction_1.Transaction.SIGHASH_ALL];
      return new Promise(function (resolve, reject) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) {
          return reject(new Error('Need HDSigner to sign input'));
        }

        var signers = getSignersFromHD(inputIndex, _this7.data.inputs, hdKeyPair);
        var promises = signers.map(function (signer) {
          return _this7.signInputAsync(inputIndex, signer, sighashTypes);
        });
        return Promise.all(promises).then(function () {
          resolve();
        }).catch(reject);
      });
    }
  }, {
    key: "signAllInputs",
    value: function signAllInputs(keyPair) {
      var sighashTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [transaction_1.Transaction.SIGHASH_ALL];
      if (!keyPair || !keyPair.publicKey) throw new Error('Need Signer to sign input'); // TODO: Add a pubkey/pubkeyhash cache to each input
      // as input information is added, then eventually
      // optimize this method.

      var results = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = range(this.data.inputs.length)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var i = _step4.value;

          try {
            this.signInput(i, keyPair, sighashTypes);
            results.push(true);
          } catch (err) {
            results.push(false);
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (results.every(function (v) {
        return v === false;
      })) {
        throw new Error('No inputs were signed');
      }

      return this;
    }
  }, {
    key: "signAllInputsAsync",
    value: function signAllInputsAsync(keyPair) {
      var _this8 = this;

      var sighashTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [transaction_1.Transaction.SIGHASH_ALL];
      return new Promise(function (resolve, reject) {
        if (!keyPair || !keyPair.publicKey) return reject(new Error('Need Signer to sign input')); // TODO: Add a pubkey/pubkeyhash cache to each input
        // as input information is added, then eventually
        // optimize this method.

        var results = [];
        var promises = [];
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = _this8.data.inputs.entries()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _ref4 = _step5.value;

            var _ref3 = _slicedToArray(_ref4, 1);

            var i = _ref3[0];
            promises.push(_this8.signInputAsync(i, keyPair, sighashTypes).then(function () {
              results.push(true);
            }, function () {
              results.push(false);
            }));
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        return Promise.all(promises).then(function () {
          if (results.every(function (v) {
            return v === false;
          })) {
            return reject(new Error('No inputs were signed'));
          }

          resolve();
        });
      });
    }
  }, {
    key: "signInput",
    value: function signInput(inputIndex, keyPair) {
      var sighashTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [transaction_1.Transaction.SIGHASH_ALL];
      if (!keyPair || !keyPair.publicKey) throw new Error('Need Signer to sign input');

      var _getHashAndSighashTyp = getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes),
          hash = _getHashAndSighashTyp.hash,
          sighashType = _getHashAndSighashTyp.sighashType;

      var partialSig = [{
        pubkey: keyPair.publicKey,
        signature: bscript.signature.encode(keyPair.sign(hash), sighashType)
      }];
      this.data.updateInput(inputIndex, {
        partialSig: partialSig
      });
      return this;
    }
  }, {
    key: "signInputAsync",
    value: function signInputAsync(inputIndex, keyPair) {
      var _this9 = this;

      var sighashTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [transaction_1.Transaction.SIGHASH_ALL];
      return new Promise(function (resolve, reject) {
        if (!keyPair || !keyPair.publicKey) return reject(new Error('Need Signer to sign input'));

        var _getHashAndSighashTyp2 = getHashAndSighashType(_this9.data.inputs, inputIndex, keyPair.publicKey, _this9.__CACHE, sighashTypes),
            hash = _getHashAndSighashTyp2.hash,
            sighashType = _getHashAndSighashTyp2.sighashType;

        Promise.resolve(keyPair.sign(hash)).then(function (signature) {
          var partialSig = [{
            pubkey: keyPair.publicKey,
            signature: bscript.signature.encode(signature, sighashType)
          }];

          _this9.data.updateInput(inputIndex, {
            partialSig: partialSig
          });

          resolve();
        });
      });
    }
  }, {
    key: "toBuffer",
    value: function toBuffer() {
      return this.data.toBuffer();
    }
  }, {
    key: "toHex",
    value: function toHex() {
      return this.data.toHex();
    }
  }, {
    key: "toBase64",
    value: function toBase64() {
      return this.data.toBase64();
    }
  }, {
    key: "updateGlobal",
    value: function updateGlobal(updateData) {
      this.data.updateGlobal(updateData);
      return this;
    }
  }, {
    key: "updateInput",
    value: function updateInput(inputIndex, updateData) {
      this.data.updateInput(inputIndex, updateData);

      if (updateData.nonWitnessUtxo) {
        addNonWitnessTxCache(this.__CACHE, this.data.inputs[inputIndex], inputIndex);
      }

      return this;
    }
  }, {
    key: "updateOutput",
    value: function updateOutput(outputIndex, updateData) {
      this.data.updateOutput(outputIndex, updateData);
      return this;
    }
  }, {
    key: "addUnknownKeyValToGlobal",
    value: function addUnknownKeyValToGlobal(keyVal) {
      this.data.addUnknownKeyValToGlobal(keyVal);
      return this;
    }
  }, {
    key: "addUnknownKeyValToInput",
    value: function addUnknownKeyValToInput(inputIndex, keyVal) {
      this.data.addUnknownKeyValToInput(inputIndex, keyVal);
      return this;
    }
  }, {
    key: "addUnknownKeyValToOutput",
    value: function addUnknownKeyValToOutput(outputIndex, keyVal) {
      this.data.addUnknownKeyValToOutput(outputIndex, keyVal);
      return this;
    }
  }, {
    key: "clearFinalizedInput",
    value: function clearFinalizedInput(inputIndex) {
      this.data.clearFinalizedInput(inputIndex);
      return this;
    }
  }, {
    key: "inputCount",
    get: function get() {
      return this.data.inputs.length;
    }
  }], [{
    key: "fromBase64",
    value: function fromBase64(data) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var buffer = Buffer.from(data, 'base64');
      return this.fromBuffer(buffer, opts);
    }
  }, {
    key: "fromHex",
    value: function fromHex(data) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var buffer = Buffer.from(data, 'hex');
      return this.fromBuffer(buffer, opts);
    }
  }, {
    key: "fromBuffer",
    value: function fromBuffer(buffer) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var psbtBase = bip174_1.Psbt.fromBuffer(buffer, transactionFromBuffer);
      var psbt = new Psbt(opts, psbtBase);
      checkTxForDupeIns(psbt.__CACHE.__TX, psbt.__CACHE);
      return psbt;
    }
  }]);

  return Psbt;
}();

exports.Psbt = Psbt;
/**
 * This function is needed to pass to the bip174 base class's fromBuffer.
 * It takes the "transaction buffer" portion of the psbt buffer and returns a
 * Transaction (From the bip174 library) interface.
 */

var transactionFromBuffer = function transactionFromBuffer(buffer) {
  return new PsbtTransaction(buffer);
};
/**
 * This class implements the Transaction interface from bip174 library.
 * It contains a bitcoinjs-lib Transaction object.
 */


var PsbtTransaction =
/*#__PURE__*/
function () {
  function PsbtTransaction() {
    var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Buffer.from([2, 0, 0, 0, 0, 0, 0, 0, 0, 0]);

    _classCallCheck(this, PsbtTransaction);

    this.tx = transaction_1.Transaction.fromBuffer(buffer);
    checkTxEmpty(this.tx);
    Object.defineProperty(this, 'tx', {
      enumerable: false,
      writable: true
    });
  }

  _createClass(PsbtTransaction, [{
    key: "getInputOutputCounts",
    value: function getInputOutputCounts() {
      return {
        inputCount: this.tx.ins.length,
        outputCount: this.tx.outs.length
      };
    }
  }, {
    key: "addInput",
    value: function addInput(input) {
      if (input.hash === undefined || input.index === undefined || !Buffer.isBuffer(input.hash) && typeof input.hash !== 'string' || typeof input.index !== 'number') {
        throw new Error('Error adding input.');
      }

      var hash = typeof input.hash === 'string' ? bufferutils_1.reverseBuffer(Buffer.from(input.hash, 'hex')) : input.hash;
      this.tx.addInput(hash, input.index, input.sequence);
    }
  }, {
    key: "addOutput",
    value: function addOutput(output) {
      if (output.script === undefined || output.value === undefined || !Buffer.isBuffer(output.script) || typeof output.value !== 'number') {
        throw new Error('Error adding output.');
      }

      this.tx.addOutput(output.script, output.value);
    }
  }, {
    key: "toBuffer",
    value: function toBuffer() {
      return this.tx.toBuffer();
    }
  }]);

  return PsbtTransaction;
}();

function canFinalize(input, script, scriptType) {
  switch (scriptType) {
    case 'pubkey':
    case 'pubkeyhash':
    case 'witnesspubkeyhash':
      return hasSigs(1, input.partialSig);

    case 'multisig':
      var p2ms = payments.p2ms({
        output: script
      });
      return hasSigs(p2ms.m, input.partialSig);

    default:
      return false;
  }
}

function hasSigs(neededSigs, partialSig) {
  if (!partialSig) return false;
  if (partialSig.length > neededSigs) throw new Error('Too many signatures');
  return partialSig.length === neededSigs;
}

function isFinalized(input) {
  return !!input.finalScriptSig || !!input.finalScriptWitness;
}

function isPaymentFactory(payment) {
  return function (script) {
    try {
      payment({
        output: script
      });
      return true;
    } catch (err) {
      return false;
    }
  };
}

var isP2MS = isPaymentFactory(payments.p2ms);
var isP2PK = isPaymentFactory(payments.p2pk);
var isP2PKH = isPaymentFactory(payments.p2pkh);
var isP2WPKH = isPaymentFactory(payments.p2wpkh);
var isP2WSHScript = isPaymentFactory(payments.p2wsh);

function check32Bit(num) {
  if (typeof num !== 'number' || num !== Math.floor(num) || num > 0xffffffff || num < 0) {
    throw new Error('Invalid 32 bit integer');
  }
}

function checkFees(psbt, cache, opts) {
  var feeRate = cache.__FEE_RATE || psbt.getFeeRate();

  var vsize = cache.__EXTRACTED_TX.virtualSize();

  var satoshis = feeRate * vsize;

  if (feeRate >= opts.maximumFeeRate) {
    throw new Error("Warning: You are paying around ".concat((satoshis / 1e8).toFixed(8), " in ") + "fees, which is ".concat(feeRate, " satoshi per byte for a transaction ") + "with a VSize of ".concat(vsize, " bytes (segwit counted as 0.25 byte per ") + "byte). Use setMaximumFeeRate method to raise your threshold, or " + "pass true to the first arg of extractTransaction.");
  }
}

function checkInputsForPartialSig(inputs, action) {
  inputs.forEach(function (input) {
    var _throws = false;
    var pSigs = [];

    if ((input.partialSig || []).length === 0) {
      if (!input.finalScriptSig && !input.finalScriptWitness) return;
      pSigs = getPsigsFromInputFinalScripts(input);
    } else {
      pSigs = input.partialSig;
    }

    pSigs.forEach(function (pSig) {
      var _bscript$signature$de = bscript.signature.decode(pSig.signature),
          hashType = _bscript$signature$de.hashType;

      var whitelist = [];
      var isAnyoneCanPay = hashType & transaction_1.Transaction.SIGHASH_ANYONECANPAY;
      if (isAnyoneCanPay) whitelist.push('addInput');
      var hashMod = hashType & 0x1f;

      switch (hashMod) {
        case transaction_1.Transaction.SIGHASH_ALL:
          break;

        case transaction_1.Transaction.SIGHASH_SINGLE:
        case transaction_1.Transaction.SIGHASH_NONE:
          whitelist.push('addOutput');
          whitelist.push('setInputSequence');
          break;
      }

      if (whitelist.indexOf(action) === -1) {
        _throws = true;
      }
    });

    if (_throws) {
      throw new Error('Can not modify transaction, signatures exist.');
    }
  });
}

function checkPartialSigSighashes(input) {
  if (!input.sighashType || !input.partialSig) return;
  var partialSig = input.partialSig,
      sighashType = input.sighashType;
  partialSig.forEach(function (pSig) {
    var _bscript$signature$de2 = bscript.signature.decode(pSig.signature),
        hashType = _bscript$signature$de2.hashType;

    if (sighashType !== hashType) {
      throw new Error('Signature sighash does not match input sighash type');
    }
  });
}

function checkScriptForPubkey(pubkey, script, action) {
  var pubkeyHash = crypto_1.hash160(pubkey);
  var decompiled = bscript.decompile(script);
  if (decompiled === null) throw new Error('Unknown script error');
  var hasKey = decompiled.some(function (element) {
    if (typeof element === 'number') return false;
    return element.equals(pubkey) || element.equals(pubkeyHash);
  });

  if (!hasKey) {
    throw new Error("Can not ".concat(action, " for this input with the key ").concat(pubkey.toString('hex')));
  }
}

function checkTxEmpty(tx) {
  var isEmpty = tx.ins.every(function (input) {
    return input.script && input.script.length === 0 && input.witness && input.witness.length === 0;
  });

  if (!isEmpty) {
    throw new Error('Format Error: Transaction ScriptSigs are not empty');
  }
}

function checkTxForDupeIns(tx, cache) {
  tx.ins.forEach(function (input) {
    checkTxInputCache(cache, input);
  });
}

function checkTxInputCache(cache, input) {
  var key = bufferutils_1.reverseBuffer(Buffer.from(input.hash)).toString('hex') + ':' + input.index;
  if (cache.__TX_IN_CACHE[key]) throw new Error('Duplicate input detected.');
  cache.__TX_IN_CACHE[key] = 1;
}

function scriptCheckerFactory(payment, paymentScriptName) {
  return function (inputIndex, scriptPubKey, redeemScript) {
    var redeemScriptOutput = payment({
      redeem: {
        output: redeemScript
      }
    }).output;

    if (!scriptPubKey.equals(redeemScriptOutput)) {
      throw new Error("".concat(paymentScriptName, " for input #").concat(inputIndex, " doesn't match the scriptPubKey in the prevout"));
    }
  };
}

var checkRedeemScript = scriptCheckerFactory(payments.p2sh, 'Redeem script');
var checkWitnessScript = scriptCheckerFactory(payments.p2wsh, 'Witness script');

function getTxCacheValue(key, name, inputs, c) {
  if (!inputs.every(isFinalized)) throw new Error("PSBT must be finalized to calculate ".concat(name));
  if (key === '__FEE_RATE' && c.__FEE_RATE) return c.__FEE_RATE;
  if (key === '__FEE' && c.__FEE) return c.__FEE;
  var tx;
  var mustFinalize = true;

  if (c.__EXTRACTED_TX) {
    tx = c.__EXTRACTED_TX;
    mustFinalize = false;
  } else {
    tx = c.__TX.clone();
  }

  inputFinalizeGetAmts(inputs, tx, c, mustFinalize);
  if (key === '__FEE_RATE') return c.__FEE_RATE;else if (key === '__FEE') return c.__FEE;
}

function getFinalScripts(script, scriptType, partialSig, isSegwit, isP2SH, isP2WSH) {
  var finalScriptSig;
  var finalScriptWitness; // Wow, the payments API is very handy

  var payment = getPayment(script, scriptType, partialSig);
  var p2wsh = !isP2WSH ? null : payments.p2wsh({
    redeem: payment
  });
  var p2sh = !isP2SH ? null : payments.p2sh({
    redeem: p2wsh || payment
  });

  if (isSegwit) {
    if (p2wsh) {
      finalScriptWitness = witnessStackToScriptWitness(p2wsh.witness);
    } else {
      finalScriptWitness = witnessStackToScriptWitness(payment.witness);
    }

    if (p2sh) {
      finalScriptSig = p2sh.input;
    }
  } else {
    if (p2sh) {
      finalScriptSig = p2sh.input;
    } else {
      finalScriptSig = payment.input;
    }
  }

  return {
    finalScriptSig: finalScriptSig,
    finalScriptWitness: finalScriptWitness
  };
}

function getHashAndSighashType(inputs, inputIndex, pubkey, cache, sighashTypes) {
  var input = utils_1.checkForInput(inputs, inputIndex);

  var _getHashForSig = getHashForSig(inputIndex, input, cache, sighashTypes),
      hash = _getHashForSig.hash,
      sighashType = _getHashForSig.sighashType,
      script = _getHashForSig.script;

  checkScriptForPubkey(pubkey, script, 'sign');
  return {
    hash: hash,
    sighashType: sighashType
  };
}

function getHashForSig(inputIndex, input, cache, sighashTypes) {
  var unsignedTx = cache.__TX;
  var sighashType = input.sighashType || transaction_1.Transaction.SIGHASH_ALL;

  if (sighashTypes && sighashTypes.indexOf(sighashType) < 0) {
    var str = sighashTypeToString(sighashType);
    throw new Error("Sighash type is not allowed. Retry the sign method passing the " + "sighashTypes array of whitelisted types. Sighash type: ".concat(str));
  }

  var hash;
  var script;

  if (input.nonWitnessUtxo) {
    var nonWitnessUtxoTx = nonWitnessUtxoTxFromCache(cache, input, inputIndex);
    var prevoutHash = unsignedTx.ins[inputIndex].hash;
    var utxoHash = nonWitnessUtxoTx.getHash(); // If a non-witness UTXO is provided, its hash must match the hash specified in the prevout

    if (!prevoutHash.equals(utxoHash)) {
      throw new Error("Non-witness UTXO hash for input #".concat(inputIndex, " doesn't match the hash specified in the prevout"));
    }

    var prevoutIndex = unsignedTx.ins[inputIndex].index;
    var prevout = nonWitnessUtxoTx.outs[prevoutIndex];

    if (input.redeemScript) {
      // If a redeemScript is provided, the scriptPubKey must be for that redeemScript
      checkRedeemScript(inputIndex, prevout.script, input.redeemScript);
      script = input.redeemScript;
    } else {
      script = prevout.script;
    }

    if (isP2WSHScript(script)) {
      if (!input.witnessScript) throw new Error('Segwit input needs witnessScript if not P2WPKH');
      checkWitnessScript(inputIndex, script, input.witnessScript);
      hash = unsignedTx.hashForWitnessV0(inputIndex, input.witnessScript, prevout.value, sighashType);
      script = input.witnessScript;
    } else if (isP2WPKH(script)) {
      // P2WPKH uses the P2PKH template for prevoutScript when signing
      var signingScript = payments.p2pkh({
        hash: script.slice(2)
      }).output;
      hash = unsignedTx.hashForWitnessV0(inputIndex, signingScript, prevout.value, sighashType);
    } else {
      hash = unsignedTx.hashForSignature(inputIndex, script, sighashType);
    }
  } else if (input.witnessUtxo) {
    var _script; // so we don't shadow the `let script` above


    if (input.redeemScript) {
      // If a redeemScript is provided, the scriptPubKey must be for that redeemScript
      checkRedeemScript(inputIndex, input.witnessUtxo.script, input.redeemScript);
      _script = input.redeemScript;
    } else {
      _script = input.witnessUtxo.script;
    }

    if (isP2WPKH(_script)) {
      // P2WPKH uses the P2PKH template for prevoutScript when signing
      var _signingScript = payments.p2pkh({
        hash: _script.slice(2)
      }).output;
      hash = unsignedTx.hashForWitnessV0(inputIndex, _signingScript, input.witnessUtxo.value, sighashType);
      script = _script;
    } else if (isP2WSHScript(_script)) {
      if (!input.witnessScript) throw new Error('Segwit input needs witnessScript if not P2WPKH');
      checkWitnessScript(inputIndex, _script, input.witnessScript);
      hash = unsignedTx.hashForWitnessV0(inputIndex, input.witnessScript, input.witnessUtxo.value, sighashType); // want to make sure the script we return is the actual meaningful script

      script = input.witnessScript;
    } else {
      throw new Error("Input #".concat(inputIndex, " has witnessUtxo but non-segwit script: ") + "".concat(_script.toString('hex')));
    }
  } else {
    throw new Error('Need a Utxo input item for signing');
  }

  return {
    script: script,
    sighashType: sighashType,
    hash: hash
  };
}

function getPayment(script, scriptType, partialSig) {
  var payment;

  switch (scriptType) {
    case 'multisig':
      var sigs = getSortedSigs(script, partialSig);
      payment = payments.p2ms({
        output: script,
        signatures: sigs
      });
      break;

    case 'pubkey':
      payment = payments.p2pk({
        output: script,
        signature: partialSig[0].signature
      });
      break;

    case 'pubkeyhash':
      payment = payments.p2pkh({
        output: script,
        pubkey: partialSig[0].pubkey,
        signature: partialSig[0].signature
      });
      break;

    case 'witnesspubkeyhash':
      payment = payments.p2wpkh({
        output: script,
        pubkey: partialSig[0].pubkey,
        signature: partialSig[0].signature
      });
      break;
  }

  return payment;
}

function getPsigsFromInputFinalScripts(input) {
  var scriptItems = !input.finalScriptSig ? [] : bscript.decompile(input.finalScriptSig) || [];
  var witnessItems = !input.finalScriptWitness ? [] : bscript.decompile(input.finalScriptWitness) || [];
  return scriptItems.concat(witnessItems).filter(function (item) {
    return Buffer.isBuffer(item) && bscript.isCanonicalScriptSignature(item);
  }).map(function (sig) {
    return {
      signature: sig
    };
  });
}

function getScriptFromInput(inputIndex, input, cache) {
  var unsignedTx = cache.__TX;
  var res = {
    script: null,
    isSegwit: false,
    isP2SH: false,
    isP2WSH: false
  };
  res.isP2SH = !!input.redeemScript;
  res.isP2WSH = !!input.witnessScript;

  if (input.witnessScript) {
    res.script = input.witnessScript;
  } else if (input.redeemScript) {
    res.script = input.redeemScript;
  } else {
    if (input.nonWitnessUtxo) {
      var nonWitnessUtxoTx = nonWitnessUtxoTxFromCache(cache, input, inputIndex);
      var prevoutIndex = unsignedTx.ins[inputIndex].index;
      res.script = nonWitnessUtxoTx.outs[prevoutIndex].script;
    } else if (input.witnessUtxo) {
      res.script = input.witnessUtxo.script;
    }
  }

  if (input.witnessScript || isP2WPKH(res.script)) {
    res.isSegwit = true;
  }

  return res;
}

function getSignersFromHD(inputIndex, inputs, hdKeyPair) {
  var input = utils_1.checkForInput(inputs, inputIndex);

  if (!input.bip32Derivation || input.bip32Derivation.length === 0) {
    throw new Error('Need bip32Derivation to sign with HD');
  }

  var myDerivations = input.bip32Derivation.map(function (bipDv) {
    if (bipDv.masterFingerprint.equals(hdKeyPair.fingerprint)) {
      return bipDv;
    } else {
      return;
    }
  }).filter(function (v) {
    return !!v;
  });

  if (myDerivations.length === 0) {
    throw new Error('Need one bip32Derivation masterFingerprint to match the HDSigner fingerprint');
  }

  var signers = myDerivations.map(function (bipDv) {
    var node = hdKeyPair.derivePath(bipDv.path);

    if (!bipDv.pubkey.equals(node.publicKey)) {
      throw new Error('pubkey did not match bip32Derivation');
    }

    return node;
  });
  return signers;
}

function getSortedSigs(script, partialSig) {
  var p2ms = payments.p2ms({
    output: script
  }); // for each pubkey in order of p2ms script

  return p2ms.pubkeys.map(function (pk) {
    // filter partialSig array by pubkey being equal
    return (partialSig.filter(function (ps) {
      return ps.pubkey.equals(pk);
    })[0] || {}).signature; // Any pubkey without a match will return undefined
    // this last filter removes all the undefined items in the array.
  }).filter(function (v) {
    return !!v;
  });
}

function scriptWitnessToWitnessStack(buffer) {
  var offset = 0;

  function readSlice(n) {
    offset += n;
    return buffer.slice(offset - n, offset);
  }

  function readVarInt() {
    var vi = varuint.decode(buffer, offset);
    offset += varuint.decode.bytes;
    return vi;
  }

  function readVarSlice() {
    return readSlice(readVarInt());
  }

  function readVector() {
    var count = readVarInt();
    var vector = [];

    for (var i = 0; i < count; i++) {
      vector.push(readVarSlice());
    }

    return vector;
  }

  return readVector();
}

function sighashTypeToString(sighashType) {
  var text = sighashType & transaction_1.Transaction.SIGHASH_ANYONECANPAY ? 'SIGHASH_ANYONECANPAY | ' : '';
  var sigMod = sighashType & 0x1f;

  switch (sigMod) {
    case transaction_1.Transaction.SIGHASH_ALL:
      text += 'SIGHASH_ALL';
      break;

    case transaction_1.Transaction.SIGHASH_SINGLE:
      text += 'SIGHASH_SINGLE';
      break;

    case transaction_1.Transaction.SIGHASH_NONE:
      text += 'SIGHASH_NONE';
      break;
  }

  return text;
}

function witnessStackToScriptWitness(witness) {
  var buffer = Buffer.allocUnsafe(0);

  function writeSlice(slice) {
    buffer = Buffer.concat([buffer, Buffer.from(slice)]);
  }

  function writeVarInt(i) {
    var currentLen = buffer.length;
    var varintLen = varuint.encodingLength(i);
    buffer = Buffer.concat([buffer, Buffer.allocUnsafe(varintLen)]);
    varuint.encode(i, buffer, currentLen);
  }

  function writeVarSlice(slice) {
    writeVarInt(slice.length);
    writeSlice(slice);
  }

  function writeVector(vector) {
    writeVarInt(vector.length);
    vector.forEach(writeVarSlice);
  }

  writeVector(witness);
  return buffer;
}

function addNonWitnessTxCache(cache, input, inputIndex) {
  cache.__NON_WITNESS_UTXO_BUF_CACHE[inputIndex] = input.nonWitnessUtxo;
  var tx = transaction_1.Transaction.fromBuffer(input.nonWitnessUtxo);
  cache.__NON_WITNESS_UTXO_TX_CACHE[inputIndex] = tx;
  var self = cache;
  var selfIndex = inputIndex;
  delete input.nonWitnessUtxo;
  Object.defineProperty(input, 'nonWitnessUtxo', {
    enumerable: true,
    get: function get() {
      var buf = self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex];
      var txCache = self.__NON_WITNESS_UTXO_TX_CACHE[selfIndex];

      if (buf !== undefined) {
        return buf;
      } else {
        var newBuf = txCache.toBuffer();
        self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = newBuf;
        return newBuf;
      }
    },
    set: function set(data) {
      self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = data;
    }
  });
}

function inputFinalizeGetAmts(inputs, tx, cache, mustFinalize) {
  var inputAmount = 0;
  inputs.forEach(function (input, idx) {
    if (mustFinalize && input.finalScriptSig) tx.ins[idx].script = input.finalScriptSig;

    if (mustFinalize && input.finalScriptWitness) {
      tx.ins[idx].witness = scriptWitnessToWitnessStack(input.finalScriptWitness);
    }

    if (input.witnessUtxo) {
      inputAmount += input.witnessUtxo.value;
    } else if (input.nonWitnessUtxo) {
      var nwTx = nonWitnessUtxoTxFromCache(cache, input, idx);
      var vout = tx.ins[idx].index;
      var out = nwTx.outs[vout];
      inputAmount += out.value;
    }
  });
  var outputAmount = tx.outs.reduce(function (total, o) {
    return total + o.value;
  }, 0);
  var fee = inputAmount - outputAmount;

  if (fee < 0) {
    throw new Error('Outputs are spending more than Inputs');
  }

  var bytes = tx.virtualSize();
  cache.__FEE = fee;
  cache.__EXTRACTED_TX = tx;
  cache.__FEE_RATE = Math.floor(fee / bytes);
}

function nonWitnessUtxoTxFromCache(cache, input, inputIndex) {
  var c = cache.__NON_WITNESS_UTXO_TX_CACHE;

  if (!c[inputIndex]) {
    addNonWitnessTxCache(cache, input, inputIndex);
  }

  return c[inputIndex];
}

function classifyScript(script) {
  if (isP2WPKH(script)) return 'witnesspubkeyhash';
  if (isP2PKH(script)) return 'pubkeyhash';
  if (isP2MS(script)) return 'multisig';
  if (isP2PK(script)) return 'pubkey';
  return 'nonstandard';
}

function range(n) {
  return _toConsumableArray(Array(n).keys());
}